import {Constructor} from "../../../global/constructor";
import PropertySection from "~/models/objectModels/propertySection";
import {Hash} from "~/interfaces/hashInterfaces";
import {ObjectHelper} from "~/helpers/objectHelper";

export default function PropertySectionContainer<TBase extends Constructor>(Base: TBase) {
  return class extends Base {
    id: string;
    client_id: string;
    property_sections: Hash<PropertySection> = {};
    saveChangesToStore: () => void;

    // look into deduping this
    get propertySectionsArray(): PropertySection[] {
      return ObjectHelper.toArray(this.property_sections)
        .sort((a, b) => a.sort_order - b.sort_order);
    }

    get hasSections(): boolean {
      return Object.keys(this.property_sections).length > 0;
    }
  };
}